import { create } from 'zustand';

type HistoryPaginationState = {
  nextCursor: number | null;
  hasMore: boolean;
};

type ChatHistoryPaginationStore = {
  paginationByChatId: Map<string, HistoryPaginationState>;
  getHistoryPagination: (chatId: string) => HistoryPaginationState | undefined;
  setHistoryPagination: ({
    chatId,
    nextCursor,
    hasMore,
  }: {
    chatId: string;
    nextCursor: number | null;
    hasMore: boolean;
  }) => void;
  clearHistoryPagination: (chatId: string) => void;
  clearAllHistoryPagination: () => void;
};

export const useChatHistoryPaginationStore = create<ChatHistoryPaginationStore>(
  (set, get) => ({
    paginationByChatId: new Map(),

    getHistoryPagination: (chatId: string) =>
      get().paginationByChatId.get(chatId),

    setHistoryPagination: ({ chatId, nextCursor, hasMore }) => {
      const paginationByChatId = new Map(get().paginationByChatId);
      paginationByChatId.set(chatId, { nextCursor, hasMore });
      set({ paginationByChatId });
    },

    clearHistoryPagination: (chatId: string) => {
      const paginationByChatId = new Map(get().paginationByChatId);
      paginationByChatId.delete(chatId);
      set({ paginationByChatId });
    },

    clearAllHistoryPagination: () => {
      set({ paginationByChatId: new Map() });
    },
  }),
);
